<template>
  <t-select
    v-bind="$attrs"
    v-model="internalValue"
    :items="genders"
    item-title="name"
    item-value="id"
  />
</template>

<script setup lang="ts">
import { computed, ref, type Ref } from "vue";
import TSelect from "./TSelect.vue";

const {
  modelValue,
} = defineProps<{
  modelValue: number | null;
}>();

const emit = defineEmits<{
  "update:modelValue": [value: number | null];
}>();

const internalValue = computed<number | null>({
  get: () => modelValue,
  set: (value: number | null) => {
    emit("update:modelValue", value);
  },
});

const genders: Ref<{ id: number; name: string }[]> = ref([
  {
    id: 1,
    name: "Masculino",
  },
  {
    id: 2,
    name: "Feminino",
  },
  {
    id: 3,
    name: "Não Binário",
  },
  {
    id: 4,
    name: "Prefiro não especificar",
  },
]);

</script>
